import { createFeatureSelector, createSelector } from '@ngrx/store';
import { HubConnectionState } from 'src/app/root-store/hub-connection-store/hub-connection.state';

export const hubConnectionFeatureKey = 'hubConnection';
export const hubConnectionFeatureKeyFeature = createFeatureSelector<HubConnectionState>(hubConnectionFeatureKey);

export const selectHubConnectionActive = createSelector(
    hubConnectionFeatureKeyFeature,
    (state: HubConnectionState) => state.isActive
);

export const selectComplianceHubConnectionActive = createSelector(
    hubConnectionFeatureKeyFeature,
    (state: HubConnectionState) => state.isComplianceActive
);
